import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import { ChangeLookESDoc } from './change-look.interfaces';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import { Indexable } from '../indexable';
import ProdBase from '../prod-base.entity';
import Production from '../productions/production.entity';
import { Taggable } from '../taggable';

export default class ChangeLook
	extends ProdBase
	implements Indexable<ChangeLookESDoc>, Taggable {
	@PrimaryGeneratedColumn()
	id: number;

	@Column('varchar')
	mobile_id: string;

	@Column('int')
	prod_id: number;

	@Column('int')
	char_id: number;

	@Column('varchar')
	change_num: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	main_photo_id: number;

	change_description: string;

	static rules() {
		return {
			change_num: Joi.string().trim().invalid('').min(1).max(50),
			char_id: Joi.number().integer(),
			created_by: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			id: Joi.number().integer(),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			main_photo_id: Joi.number().integer().allow(null),
			mobile_id: Joi.string().max(36).allow(null, ''),
			prod_id: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			change_num: this.change_num,
			change_description: this.change_description,
			char_id: this.char_id,
			created_by: this.created_by,
			date_created: this.date_created,
			id: this.id,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			main_photo_id: this.main_photo_id,
			mobile_id: this.mobile_id,
			prod_id: this.prod_id,
		};
	}

	toESDoc(data?: {
		episodicCharacter?: EpisodicCharacter;
		production?: Production;
	}) {
		let char_first_name: string,
			char_last_name: string,
			char_num: string,
			episode_num: string;

		if (data) {
			const { episodicCharacter, production } = data;
			if (episodicCharacter === null) {
				char_first_name = null;
				char_last_name = null;
				char_num = null;
			} else if (episodicCharacter) {
				char_first_name = episodicCharacter.first_name;
				char_last_name = episodicCharacter.last_name;
				char_num = episodicCharacter.char_num;
			}

			if (production) {
				episode_num = production.episode_num;
			}
		}

		return {
			id: this.id,
			prod_id: this.prod_id,
			change_num: this.change_num,
			char_first_name,
			char_last_name,
			char_id: this.char_id,
			description: this.changeDescription,
			episode_num,
			char_num,
		};
	}

	assign(props?: GenPartial<ChangeLook>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<ChangeLook>) {
		super(props);
	}

	get changeDescription() {
		return this.change_description;
	}

	getTagName() {
		return this.change_num;
	}
}
